<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- Page Header -->
            <page-header :title="title" />
            <!-- /Page Header -->
  
            <div class="card">
              <!-- Search -->
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col-sm-4">
                    <div class="icon-form mb-3 mb-sm-0">
                      <span class="form-icon"><i class="ti ti-search"></i></span>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search Countries"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Search -->
              <div class="card-body">
                <!-- Countries List -->
                <div v-if="!isLoading" class="table-responsive custom-table">
                  <a-table
                    class="table"
                    :columns="columns"
                    :data-source="data"
                    :row-selection="rowSelection"
                    row-key="id"
                  >
                    <template #bodyCell="{ column, record }">
                      <!-- Render Action Column -->
                      <template v-if="column.key === 'action'">
                        <div class="dropdown table-action">
                          <a
                            href="#"
                            class="action-icon"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="fa fa-ellipsis-v"></i
                          ></a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              @click="rejectEditRequest(record)"
                            >
                              <i class="fas fa-times-circle text-danger"></i> Reject
                            </a>
  
  
                            <a
                              class="dropdown-item"
                              href="#"
                              @click="confirmEditRequest(record)" >
                              <i class="fas fa-check-circle text-blue"></i> Approve
                            </a>
                          </div>
                        </div>
                      </template>
  
                      <template v-else-if=" column.key === 'lead_id' && record?.lead">
                        <strong>{{ record?.lead.id }}</strong>
                      </template>
                      <template v-else-if=" column.key === 'org_name' && record?.lead?.initial_info">
                        <strong>{{ record?.lead?.initial_info.organization_name }}</strong>
                      </template>
                      <template v-else-if=" column.key === 'employee_name' && record?.employee?.user">
                        <strong>{{ record?.employee?.user.name }}</strong>
                      </template>
                      <template v-else-if=" column.key === 'permission_type' && record?.permission_type">
                        <strong>{{ record?.permission_type }}</strong>
                      </template>
                      <template
                        v-else-if="
                          column.key === 'created_at' && record?.created_at
                        "
                      >
                        {{ formatDate(record.created_at) }}
                      </template>
                    </template>
                  </a-table>
                </div>
  
                <!-- Loading indicator -->
                <div v-else>
                  <p>Loading...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lead-delete-modal v-if="isShowModal" @refresh="refresh" />
  </template>
  
  <script>
  import http from "@/utils/http";
  import moment from "moment";
  import {mapGetters} from "vuex";
  
  export default {
    data() {
      return {
        title: "Leads Edit Requests",
        data: [],
        permissions: [],
        isLoading: true,
        isEditMode: false,
        isShowModal: false,
        columns: [
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            sorter: (a, b) => a.id - b.id,
          },
          {
            title: "Lead ID",
            key: "lead_id",
          },
          {
            title: "Organization Name",
            key: "org_name",
          },
          {
            title: "Employee Name",
            key: "employee_name",
          },
          {
            title: "Permission Type",
            key: "permission_type",
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sorter: (a, b) => a.status.localeCompare(b.status),
          },
          {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            sorter: (a, b) => a.created_at.localeCompare(b.created_at),
          },
          {
            title: "Action",
            key: "action",
          },
        ],
  
        rowSelection: {
          onChange: () => {},
          onSelect: () => {},
          onSelectAll: () => {},
        },
      };
    },
    computed: {
     ...mapGetters(["userInfo"]),
    },
    mounted() {
      this.getCollections();
    },
    methods: {
      async getCollections() {
        this.isLoading = true;
        try {
          const response = await http.get("all-leads-edit-requests");
          this.data = response.data.contents;
        } catch (error) {
          console.error("Error:", error);
        } finally {
          this.isLoading = false;
        }
      },
      refresh() {
        this.isShowModal = false;
        this.getCollections();
      },
  
      goToUrl(path) {
        this.$router.push(path);
      },
      goToEditPage(recordId) {
        this.$router.push(`/leads-organization/${recordId}/initial-info`);
      },
      goToDetailsPage(recordId) {
        this.$router.push(`/leads-organization/${recordId}/leads-details`);
      },
      formatDate(date) {
        return moment(date).format("DD-MM-YYYY");
      },
      openDeleteModal(row = "") {
        this.isShowModal = true;
        setTimeout(() => {
          this.$emitter.emit("delete-item-modal", row);
        });
      },

      confirmEditRequest(record){
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to give the edit request to this employee?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Approve it!",
        }).then((result) => {
            if (result.isConfirmed) {
                this.editRequestAction(record.id, record.permission_type, 'approved');
            }
        });
      },

      rejectEditRequest(record){
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to Reject the edit request?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Reject it!",
        }).then((result) => {
            if (result.isConfirmed) {
                this.editRequestAction(record.id, record.permission_type, 'reject');
            }
        });
      },

      async editRequestAction(recordId, permissionType, actionType){
        const endpoint = "/leads-edit-request-action";
        const method = "post";
        let body = {
            id: recordId,
            permissionType: permissionType,
            actionType: actionType
        };
        try {
            const response = await http[method](endpoint, body);
            this.$toast.success(response.data.message);
            this.$store.commit("updateSupervisorNotification", response.data.notification);
            this.refresh()
        } catch (error) {
            this.$toast.error(error.response.data.message);
        } 
        finally {
          //
        }
      }
    },
  };
  </script>
  